@if (showedLoader) {
<div class="app-ajax-loader" [class.full-width-loader]="ajaxLoaderService.isFullWidth()">
    <ng-progress id="app-ajax-progress" [spinner]="false"></ng-progress>
</div>
}
